import { render, staticRenderFns } from "./OrganizationCreateDialog.vue?vue&type=template&id=64d3cc22&scoped=true"
import script from "./OrganizationCreateDialog.vue?vue&type=script&lang=js"
export * from "./OrganizationCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./OrganizationCreateDialog.vue?vue&type=style&index=0&id=64d3cc22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d3cc22",
  null
  
)

export default component.exports